export default {
      id: "xtype_xtrack-usage",
      viewBox: "0 0 18 15",
      url: __webpack_public_path__ + "img/icons.svg#xtype_xtrack",
      toString: function () {
        return this.url;
      }
    }